import { useConnection } from '@/store/connection';

/**
 * Tek global bağlantı uyarısı (Faz 1). connection store 'offline' iken görünür —
 * backend/sunucu ulaşılamıyor, canlı veriler donduruldu. Component-başı yama
 * yerine TEK yer; bütün canlı UI aynı sinyalden tutarlı davranır.
 */
export function ConnectionBanner() {
  const status = useConnection((s) => s.status);
  if (status !== 'offline') return null;
  return (
    <div className="bg-red-600 text-white text-[12px] font-medium px-4 py-1.5 flex items-center justify-center gap-2 flex-shrink-0 z-50">
      <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse flex-shrink-0" />
      Sunucu bağlantısı yok — yeniden bağlanılıyor… Canlı veriler donduruldu.
    </div>
  );
}
